import {SecureService} from "@/services/superclasses/secure-service";
import {CorporateClient} from "@/interfaces/corporate-client";
import {Person} from "@/interfaces/person";

const api = window.contextPath + '/rest/corporate-clients';

export class CorporateClientSecureService extends SecureService {

    public loadByPerson = async (): Promise<CorporateClient> => {
        return this.data(await this.get<CorporateClient>(`${api}/by-person`))
    };

    public loadById = async (corporateClientId: number): Promise<CorporateClient> => {
        return this.data(await this.get<CorporateClient>(`${api}/` + corporateClientId))
    };

    public loadPersons = async (corporateClientId: number): Promise<Person[]> => {
        return this.data(await this.get<Person[]>(`${api}/` + corporateClientId + '/persons'))
    };

    public loadAdmins = async (corporateClientId: number): Promise<Person[]> => {
        return this.data(await this.get<Person[]>(`${api}/` + corporateClientId + '/admins'))
    };

    public loadContacts = async (corporateClientId: number): Promise<any> => {
        return this.data(await this.get<any>(`${api}/` + corporateClientId + '/contacts'))
    };

    public loadReadData = async (corporateClientId: number): Promise<any> => {
        return this.data(await this.get<any>(`${api}/` + corporateClientId + '/most-read'))
    };

    public deleteSubscription = async (personId: number, corporateClientId: number): Promise<void> => {
        return this.data(await this.delete<any>(`${api}/` + corporateClientId + '/subscriptions/' + personId))
    };

    public invitePerson = async (email: string, corporateClientId: number): Promise<void> => {
        return this.data(await this.post<any>(`${api}/` + corporateClientId + '/invitations', {"email": email},
            {headers: {'content-type': 'application/x-www-form-urlencoded'}}))
    };
}

export const corporateClientSecureService = new CorporateClientSecureService()